import { Link } from "react-router-dom";

const Breadcrumb = ({ items }) => {
  if (items.length === 0) return null;

  return (
    <nav className="flex mb-4" aria-label="Breadcrumb">
      <ol className="inline-flex items-center space-x-1 md:space-x-3">
        {items.map((item, index) => (
          <li key={item.id || index} className="inline-flex items-center">
            {index > 0 && (
              <svg
                className="w-5 h-5 text-gray-400"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            )}
            {item.path ? (
              <Link
                to={item.path}
                className="text-gray-700 hover:text-blue-600 text-sm font-medium inline-flex items-center"
              >
                {item.name}
              </Link>
            ) : (
              <span
                className={`${
                  item.current
                    ? "text-blue-600 font-semibold"
                    : "text-gray-500"
                } text-sm font-medium inline-flex items-center`}
              >
                {item.name}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;